// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2760":"02a7caeb","4631":"68f783d5","7012":"68f783d5","9683":"69de803a"}[chunkId] + ".chunk.css";
};